import { Link, useLocation } from "wouter";
import { cn } from "@/lib/utils";
import { 
  LayoutDashboard, 
  MessageSquare, 
  AlertTriangle, 
  Settings,
  StickyNote,
  Users
} from "lucide-react";

const navItems = [
  { href: "/", label: "Home", icon: LayoutDashboard },
  { href: "/chats", label: "Chats", icon: MessageSquare },
  { href: "/notes", label: "Notes", icon: StickyNote },
  { href: "/alerts", label: "Alerts", icon: AlertTriangle },
  { href: "/settings/team", label: "Team", icon: Users },
  { href: "/settings", label: "Settings", icon: Settings },
];

export function BottomNav() {
  const [location] = useLocation();

  return (
    <nav className="fixed bottom-0 left-0 right-0 z-50 bg-background/80 backdrop-blur-lg border-t border-border/60 pb-[env(safe-area-inset-bottom)] shadow-[0_-4px_20px_rgba(0,0,0,0.03)]">
      <div className="flex items-center justify-around h-16 px-2">
        {navItems.map((item) => {
          const isActive = location === item.href || 
            (item.href !== "/" && location.startsWith(item.href));
          
          return (
            <Link key={item.href} href={item.href}>
              <div
                className={cn(
                  "flex flex-col items-center justify-center min-w-[64px] h-12 rounded-xl gap-1 transition-all duration-300 cursor-pointer active:scale-90",
                  isActive
                    ? "text-primary bg-primary/5 shadow-inner"
                    : "text-muted-foreground/60 hover:text-foreground"
                )}
              >
                <div className={cn(
                  "p-1 rounded-lg transition-all duration-300",
                  isActive && "scale-110"
                )}>
                  <item.icon className={cn("w-5 h-5 transition-all", isActive && "stroke-[2.5px]")} />
                </div>
                <span className={cn(
                  "text-[9px] font-bold uppercase tracking-wider transition-all",
                  isActive ? "opacity-100" : "opacity-60"
                )}>
                  {item.label}
                </span>
              </div>
            </Link>
          );
        })}
      </div>
    </nav>
  );
}
